import { ref, unref } from 'vue'

const PRO_TO_PLUS_ACCOMMODATION_ID_KEY = 'pro_to_plus_accommodation_id'

const isProToPlusModalOpen = ref(false)
const proToPlusAccommodationId = ref(window.localStorage.getItem(PRO_TO_PLUS_ACCOMMODATION_ID_KEY))
const proToPlusSource = ref(null)

export function useProToPlusReactivation() {
  const openProToPlusModal = (itemId, source = null) => {
    const resolvedId = unref(itemId)
    proToPlusSource.value = source
    isProToPlusModalOpen.value = true
    proToPlusAccommodationId.value = resolvedId
    if (resolvedId) {
      window.localStorage.setItem(PRO_TO_PLUS_ACCOMMODATION_ID_KEY, String(resolvedId))
    }
  }

  const closeProToPlusModal = () => {
    proToPlusSource.value = null
    isProToPlusModalOpen.value = false
    proToPlusAccommodationId.value = null
    window.localStorage.removeItem(PRO_TO_PLUS_ACCOMMODATION_ID_KEY)
  }

  return {
    isProToPlusModalOpen,
    proToPlusAccommodationId,
    proToPlusSource,
    openProToPlusModal,
    closeProToPlusModal,
  }
}
